export const generateSimpleStruct = (graphIndex) => {
    const newStruct = {
        type: "item",
        content: `GRAPH${graphIndex}`,
    };
    return newStruct;
};
//# sourceMappingURL=struct.js.map